import React, { useEffect, useState } from "react";
import SubNav from "../../../Shared/SubNav";
import { useLocation, useNavigate } from "react-router-dom";
import socket from "../../../context/socket";
import axios from "axios";
import { FaCheck } from "react-icons/fa";
import { MdCheck, MdDone } from "react-icons/md";
import Swal from "sweetalert2";
import { useDispatch, useSelector } from "react-redux";
import { fetchClientData } from "../../../redux/client/clientSlice";
import moment from "moment";
import api from "../../../utils/api";
import { isAction } from "@reduxjs/toolkit";

const GetOnSamePage = ({isConnected}) => {
  const navigate = useNavigate();

  const dispatch = useDispatch();

  const roomId = new URLSearchParams(window.location.search).get("clientId");
  const [isAccept, setIsAccept] = useState(null);
  const [currentIP, setUserIp] = useState(null);
  const [showAgreedToWork, setShowAgreedToWork] = useState(false);


  console.log("isAccept", isAccept);
  const [isCards, setCards] = useState();

  const [isClientData, setIsClientData] = useState();
  console.log("isClientData", isClientData, roomId);

  // For Getting Sellectd Cards data from db
  useEffect(() => {
    const fetchClientConditions = async () => {
      try {
        Swal.fire({
          // title: "Loading...",
          text: "Please wait ...",
          allowOutsideClick: false,
          didOpen: () => {
            Swal.showLoading();
          },
        });

        const response = await api.get(
          `advisor/get_client_inbelief_conditons/${roomId}`
        );

        const dataa = response.data;
        console.log("Message Received: setCards", dataa?.go_to_dream_into_action);

        if (dataa?.go_to_dream_into_action) {
          // const nextUrl = "/dreams-into-action?clientId=" + roomId;
          // socket.emit("navigate", { room: roomId, url: nextUrl });
          // navigate(nextUrl);
          setShowAgreedToWork(true)
          Swal.close(); // close loading before navigating
          return;
        }

        setCards(dataa.InvestingBeliefinfo);
        Swal.close(); // close loading after setting data
      } catch (error) {
        console.error("Error fetching data:", error);
        Swal.fire({
          icon: "error",
          title: "Failed to fetch data",
          text: "Please try again later.",
        });
      }
    };

    fetchClientConditions();
  }, [roomId]);


  useEffect(() => {
    api
      .get(
        `advisor/get_client_inbelief_conditons/${roomId}`
      )
      .then((response) => {
        const dataa = response.data;
        // console.log("Message Received: setCards", dataa);
        setCards(dataa.InvestingBeliefinfo);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  }, [roomId]);

  const { clientData: Cdata, } = useSelector((state) => state.client);

  useEffect(() => {

    if (Cdata.inv_belief_agreed==='yes' && !isConnected) {
      setIsClientData(Cdata);
      setIsAccept(Cdata.inv_belief_agreed)
      setUserIp(Cdata.inv_belief_agreed_IP)
      console.log('Cdata', isAccept,isConnected,(Cdata.inv_belief_agreed==='yes' && !isConnected), Cdata.inv_belief_agreed);
      console.log('isAccept', isAccept);
    }
  }, [Cdata]);






  useEffect(() => {
    socket.emit("gateway", { room: roomId, data: showAgreedToWork });
  }, [showAgreedToWork])

  // get Checked data from client
  useEffect(() => {
    socket.emit("join", { room: roomId });
    socket.on("message", (msg) => {
      // console.log("datasocket", msg);
      if (msg?.data?.isAccept !== undefined) {
        console.log(msg?.data?.currentIP);
        setIsAccept(msg?.data?.isAccept);
        setUserIp(msg?.data?.currentIP);
      }

    });
  }, []);

  useEffect(() => {
    sendAggredStatus();
  }, [isAccept, currentIP]);


  const sendAggredStatus = async () => {
    try {
      // Agar pehle se hi Cdata.inv_belief_agreed_date hai, to dobara mat bhejo
      // if (isAccept === "no" ) {
      if (isAccept === "yes" && (Cdata?.inv_belief_agreed === "no" || Cdata?.inv_belief_agreed === "" || !Cdata?.inv_belief_agreed)) {
        const currentDateTime = new Date().toISOString();

        await api.post("advisor/set_inbelief_agreed", {
          _id: roomId,
          inv_belief_agreed: isAccept,
          inv_belief_agreed_date: currentDateTime,
          inv_belief_agreed_IP: currentIP,
        });
        dispatch(fetchClientData(roomId));
        console.log("✅ First time agreed, saved in DB");
      } else {
        console.log("ℹ️ Already agreed earlier, skipping save");
      }
    } catch (error) {
      console.log("Some Errors", error);
    }
  };



  const handleNext = () => {
    if (showAgreedToWork) {
      const nextUrl = "/dreams-into-action?clientId=" + roomId;
      const nextUrl2 = "/dreams-into-action";

      socket.emit("navigate", { room: roomId, url: nextUrl2 });
      navigate(nextUrl);
      return;
    }
    if (isAccept === "yes") {
      const nextUrl = "/dreams-into-action?clientId=" + roomId;
      const nextUrl2 = "/dreams-into-action";

      socket.emit("navigate", { room: roomId, url: nextUrl2 });
      navigate(nextUrl);
    }
  };

  const handleBack = () => {

    const prevUrl = "/long-term-investing?clientId=" + roomId;
    const prevUrl2 = "/long-term-investing";

    socket.emit("navigate", { room: roomId, url: prevUrl2 });
    navigate(prevUrl);
  };


  const staticData = [
    {
      title: "Goal Based Investing > Chasing Returns",
      description:
        "Focus on long-term goal-based investing and staying invested, not on chasing returns or timing the market.",
    },
    {
      title: "Risk Aversion = Risky!",
      description:
        "Investing success comes from aligning risk with goal tenure, maintaining discipline, and taking calculated risks - since no risk means no reward.",
    },
    {
      title: "Discipline + Behavioral Investing",
      description:
        "True wealth creation comes from staying goal-focused and disciplined through market ups and downs, not chasing past or guaranteed returns.",
    },
    {
      title: "Trust the Investing Process!",
      description:
        "It's designed to minimize risk, curb impulsive decisions, and maximize long-term wealth through disciplined investing.",
    },
  ];

  return (
    <>
      {!showAgreedToWork ?
        <div className="container minht1">
          <div>
            <h3 className="d-block d-md-none">Let’s Get on the Same Page!</h3> {/* Mobile */}
            <h2 className="d-none d-md-block">Let’s Get on the Same Page!</h2>  {/* Desktop & Tablet */}
          </div>


          <div className="mt-4">
            <div className="card shadow-sm">
              <div className="card-body">

                <div className="scroll-container">
                  {isCards &&
                    isCards.map((card, index) => (
                      <div key={index} className="d-flex align-items-start mb-3">
                        {/* <img
                          className=" me-2"
                          src="assets/images/download.png"
                          alt="Icon"
                        /> */}
                        <span>
                          <MdDone className="fs-24 me-2 clrgreen" />
                        </span>
                        <p className="igbn m-0">
                          <span
                            style={{ fontSize: "16px" }}
                            dangerouslySetInnerHTML={{ __html: card }}
                          />
                        </p>
                      </div>
                    ))}
                </div>

                <div className="d-flex align-items-center mt-3">
                  <button
                    onClick={() => {
                      if (isAccept !== "yes") {
                        Swal.fire({
                          title: "Are you sure?",
                          icon: "warning",
                          showCancelButton: true,
                          confirmButtonText: "Ok",
                          customClass: {
                            confirmButton: "swal-confirm-btn",
                          },
                          cancelButtonText: "Cancel",
                        }).then((result) => {
                          if (result.isConfirmed) {
                            socket.emit("navigate", { room: roomId, url: `/?clientId=${roomId}` });

                            navigate(`/?clientId=${roomId}`);
                          }
                        });
                      }

                    }}

                    className={`${isAccept === "yes"
                      ? "lrgbutton text-white fw-semibold mx-auto px-3 "
                      : "mx-auto bg-danger text-white p-1 fs-14 fw-semibold border-danger "
                      }`}
                    disabled={isAccept === "yes"}
                  >
                    {isAccept === "yes" ? "Accepted" : "Expection Mismatch"}
                    <br />
                    {isAccept !== "yes" && "Drop Off"}
                  </button>


                </div>
                {isAccept === "yes" &&
                  <div className="mt-2">
                    <p className="text-center">
                      {Cdata.inv_belief_agreed_date ? moment(Cdata.inv_belief_agreed_date).format("DD MMM YYYY, h:mm A") : ""}
                    </p>
                    <p className="text-center">
                      {currentIP || ""}
                    </p>
                  </div>
                }





              </div>
            </div>

          </div>
        </div>

        :
        <>
          <div className="container minht1">
           

            <div>
              <h3 className="d-block d-md-none">We Agree To Work On</h3> {/* Mobile */}
              <h2 className="d-none d-md-block">We Agree To Work On</h2>  {/* Desktop & Tablet */}
            </div>


            <div className="mt-4">
              <div className="card shadow-sm custom-md-75 mx-auto">
                <div className="card-body ">

                  <div className="scroll-container ">
                    {staticData &&
                      staticData.map((card, index) => (
                        <div key={index} className="d-flex align-items-start mb-3">
                          {/* <img
                            className=" me-2"
                            src="assets/images/download.png"
                            alt="Icon"
                          /> */}
                          <span>
                            <MdDone className="fs-24 me-2 clrgreen" />
                          </span>
                          <p className="igbn m-0">
                            <span className="igbTitle" style={{ fontSize: "16px" }}>{card.title} &nbsp;</span>
                            <span>{card.description}</span>
                          </p>
                        </div>
                      ))}



                  </div>

                  {/* <div className="d-flex align-items-center mt-3">
                <button
                  onClick={() => {
                    if (isAccept !== "yes") {
                      Swal.fire({
                        title: "Are you sure?",
                        icon: "warning",
                        showCancelButton: true,
                        confirmButtonText: "Ok",
                        customClass: {
                          confirmButton: "swal-confirm-btn",
                        },
                        cancelButtonText: "Cancel",
                      }).then((result) => {
                        if (result.isConfirmed) {
                          socket.emit("navigate", { room: roomId, url: `/?clientId=${roomId}` });

                          navigate(`/?clientId=${roomId}`);
                        }
                      });
                    }

                  }}

                  className={`${isAccept === "yes"
                    ? "lrgbutton text-white fw-semibold mx-auto px-3 "
                    : "mx-auto bg-danger text-white p-1 fs-14 fw-semibold border-danger "
                    }`}
                  disabled={isAccept === "yes"}
                >
                  {isAccept === "yes" ? "Accepted" : "Expection Mismatch"}
                  <br />
                  {isAccept !== "yes" && "Drop Off"}
                </button>


              </div>
              {isAccept === "yes" &&
                <div className="mt-2">
                  <p className="text-center">
                    {Cdata.inv_belief_agreed_date ? moment(Cdata.inv_belief_agreed_date).format("DD MMM YYYY, h:mm A") : ""}
                  </p>
                  <p className="text-center">
                    {currentIP || ""}
                  </p>
                </div>
              } */}





                </div>
              </div>

            </div>
          </div>
        </>
      }
      <div className="container my-3"
      //  style={{position:"absolute",bottom:'0px' ,right:"230px"}}
      >
        <div className="row ">
          <div className="col text-end">
            <a href="javascript:void(0);" onClick={handleBack} className="me-2">
              <img
                className="arrow_next1"
                src="assets/images/left-arrowpng.png"
                alt="Back"
              />
            </a>
            <a href="javascript:void(0);" onClick={handleNext}>
              <img
                className="arrow_next"
                src="assets/images/right-arrow.svg"
                alt="Next"
              />
            </a>
          </div>
        </div>
      </div>
    </>

  );
};

export default GetOnSamePage;
